import { defineComponent as _defineComponent } from 'vue'
import { getDateRangeFormatted } from '@/services/date'
import { mdiDotsHorizontal } from '@mdi/js'
import { ref } from 'vue'
import { useImage } from '@/shared/composables/image'
import BKSvgIcon from '@/components/AppShared/BKSvgIcon.vue'
import { EventPreview } from '@/enitites/event/model/types'
import { useRouter } from 'vue-router/composables'
import IconLike from '@/shared/icons/IconLike.vue'
import ToggleLike from '../../../features/toggle-like/ui/ToggleLike.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileEventRow',
  props: {
    event: null
  },
  setup(__props: any) {

const props = __props as {
  event: EventPreview
};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const { getEventImg } = useImage()



const router = useRouter()

const isShowDeleteModal = ref(false)

const getEventDate = getDateRangeFormatted(props.event.dateStart, props.event.dateEnd)

const handleClickEvent = () => {
  router.push({
    name: 'Event',
    params: { id: `${props.event.id}` },
  })
}

const handleProvideFeedback = () => {
  router.push({
    name: 'Event',
    params: { id: `${props.event.id}` },
    query: { tab: 'feedback' },
  })
}

const handleReviewFeedback = () => {
  router.push({
    name: 'Event',
    params: { id: `${props.event.id}` },
    query: { tab: 'feedback' },
  })
}

return { __sfc: true,getEventImg, props, router, isShowDeleteModal, getEventDate, handleClickEvent, handleProvideFeedback, handleReviewFeedback, mdiDotsHorizontal, BKSvgIcon, IconLike, ToggleLike }
}

})